<template>
  <div id="my-signin2"></div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "GoogleLoginBtn",
  methods: {
    ...mapActions("account", ["socialLogin"]),
    // eslint-disable-next-line no-unused-vars
    onSuccess(googleUser) {
      // let token = googleUser.getAuthResponse().access_token;
      // this.socialLogin({ provider: "google", token });
    },
    onFailure(error) {
      console.log(error);
    },
    renderButton() {
      /*  
        window.gapi.signin2.render("my-signin2", {
        scope: "profile email",
        width: 240,
        height: 50,
        longtitle: true,
        theme: "dark",
        onsuccess: this.onSuccess,
        onfailure: this.onFailure
      });
      */
    }
  },
  mounted() {
    this.renderButton();
  }
};
</script>

<style></style>
